/* eslint-disable max-len */
import PropTypes from 'prop-types'

export const LocationPin = ({ style, className, fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" viewBox="0 0 36 50" style={style} className={className}>
    <path
      fill={fill}
      d="M18 0C8.075 0 0 8.123 0 18.108c0 12.391 16.108 30.583 16.794 31.351.644.722 1.769.72 2.412 0C19.892 48.691 36 30.5 36 18.108 36 8.123 27.925 0 18 0zm0 27.219c-4.994 0-9.056-4.087-9.056-9.111 0-5.024 4.062-9.11 9.056-9.11 4.994 0 9.056 4.086 9.056 9.11 0 5.024-4.062 9.11-9.056 9.11z"
    />
  </svg>
)

LocationPin.propTypes = {
  style: PropTypes.instanceOf(Object),
  className: PropTypes.string,
  fill: PropTypes.string
}

LocationPin.defaultProps = {
  style: {},
  className: undefined,
  fill: '#933ec5'
}
